import { http } from '../utils/http'

const getApplyInitAction = () => {
  const url = '/api/v1/service/permission/init'
  return http.post(url)
};
const getApproverAction = () => {
  const url = '/api/v1/service/permission/getApproves'
  return http.post(url)
};
const applyAction = (params) => {
  const url = '/api/v1/service/permission/apply'
  return http.post(url, params)
};
export default {
  getApplyInitAction,
  getApproverAction,
  applyAction,
}
